<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2">
            <app-navbar></app-navbar>
        </div>
        <div class="col-lg-10">
            <div class="row">
                <div class="col-lg-9">
                    <br>
                    <h2>Escuelas</h2>
                </div>
                <div class="col-lg-2">
                    <br>
                    <button (click)="openModal(agregarModal)" type="button" class="boton fondoAmarillo blanco bold" > Agregar <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                      </svg> </button>
                </div>
            </div>
            
            <div class="row">
                <div class="col-lg-11">
                    <table class="table table-striped row-border hover"  datatable [dtOptions]="dtOptions"
                    [dtTrigger]="dtTrigger">
                        <thead class="thead-dark">
                            <tr>
                                <td>Siglas</td>
                                <td>Nombre</td>
                                <td>Estado</td>
                                <td>Ciudad</td>
                                <td>Imagen</td>
                                <td>Escudo</td>
                                <td>Editar</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let escuela of escuelas">
                                <td>{{escuela.nombre}}</td>
                                <td>{{escuela.descripcion}}</td>
                                <td>{{escuela.estado}}</td>
                                <td>{{escuela.ciudad}}</td>
                                <td><img src="{{enviroment}}{{escuela.imagen}}" height="50px"></td>
                                <td><img src="{{enviroment}}{{escuela.escudo}}" height="50px"></td>
                                <td>
                                    <a (click)="editarEscuela(escuela.id)">
                                    <svg  style="color:gray" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-pencil-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
                                    </svg></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
</div>

<ng-template #agregarModal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h2>Agregar Escuela</h2>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
    </div>

    <div class="modal-body">
        <input type="text" class="form-control" placeholder="Siglas" [(ngModel)]="formulario.nombre"><br>
        <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="formulario.descripcion"><br>

        <select  #estadoSelect class="form-control" (change)='getMunicipios(estadoSelect.value)'>
            <option value="">Estado</option>
            <option *ngFor="let estado of estados" [value]="estado.id" >{{estado.nombre}}</option>
        </select><br>

        <select  #municipioSelect class="form-control">
            <option value="">Delegación/Municipio</option>
            <option *ngFor="let municipio of municipios" [value]="municipio.id">{{municipio.nombre}}</option>
        </select><br>

        Imagen:<br>
        <input (change)="imageChange($event.target.files)" type="file"accept="image/*" id="imagen"><br><br>

        Escudo:<br>
        <input (change)="escudoChange($event.target.files)" type="file"accept="image/*" id="escudo"><br><br>
        
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" (click)="agregarEscuela(municipioSelect.value)">Agregar</button>
    </div>
</ng-template>

<div id="clickEditar" (click)="openModal(myModalEditar)"></div>

<ng-template #myModalEditar let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h2>Editar Escuela</h2>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
    </div>

    <div class="modal-body">
        <img src="{{enviroment}}{{imagenActual}}" height="300px"><br><br>
        Imagen:<br>
        <input (change)="imageChangeEdit($event.target.files)" type="file"accept="image/*" id="imagen2"><br><br>

        
        <img src="{{enviroment}}{{escudoActual}}" height="300px"><br><br>
        Escudo:<br>
        <input (change)="escudoChangeEdit($event.target.files)" type="file"accept="image/*" id="escudo2"><br><br>

        <input type="text" class="form-control" placeholder="Siglas" [(ngModel)]="formularioEdit.nombre"><br>
        <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="formularioEdit.descripcion"><br>
        
        <select  #estadoEdit class="form-control" (change)='getMunicipios(estadoEdit.value)'>
            <option value="">Estado</option>
            <option *ngFor="let estado of estados" [value]="estado.id" [attr.selected]="estado.id==estadoSelected ? true : null">{{estado.nombre}}</option>
        </select><br>

        <select  #municipioEdit class="form-control">
            <option value="">Delegación/Municipio</option>
            <option *ngFor="let municipio of municipios" [value]="municipio.id" [attr.selected]="municipio.id==municipioSelected ? true : null">{{municipio.nombre}}</option>
        </select><br>

    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" (click)="updateEscuela(itemId, municipioEdit.value)">Actualizar</button>
    </div>
</ng-template>